export default {
      id: "kite-usage",
      viewBox: "0 0 23 30",
      url: __webpack_public_path__ + "icons.svg#kite",
      toString: function () {
        return this.url;
      }
    }